export default __webpack_public_path__ + "static/media/arrow-up-small.e77d1d02.svg";